import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import './Navbar.css';

function Navbar({ currentPage, setCurrentPage, mobileMenuOpen, setMobileMenuOpen }) {
  const logoRef = useRef(null);

  const navItems = [
    { name: 'DANTE', page: 'dante' },
    { name: 'VERGIL', page: 'vergil' },
    { name: 'WEAPONS', section: 'weapons' },
    { name: 'GALLERY', section: 'gallery' },
    { name: 'CONTACT', section: 'contact' }
  ];

  // Add spacing style for nav items
  const navItemStyle = {
    marginRight: '40px',
    display: 'inline-block'
  };

  const lastNavItemStyle = {
    marginRight: '0',
    display: 'inline-block'
  };

  const handleNavClick = (item) => {
    closeMobileMenu();
    if (item.page) {
      setCurrentPage(item.page);
      window.location.hash = item.page === 'dante' ? '' : item.page;
      window.scrollTo(0, 0);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    // GSAP logo animation
    gsap.fromTo(logoRef.current, 
      { opacity: 0, x: -50 },
      { opacity: 1, x: 0, duration: 1, ease: 'power3.out' }
    );
  }, []);

  const navVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <button className="logo-link" onClick={() => { setCurrentPage('dante'); window.location.hash = ''; window.scrollTo(0, 0); }}>
          <div ref={logoRef} className="logo">
            <span className="logo-icon">⚔</span>
            <span className="logo-text">DMC</span>
          </div>
        </button>

        {/* Mobile Menu Toggle */}
        <button 
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav Links */}
        <motion.ul 
          className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}
          variants={navVariants}
          initial="hidden"
          animate="visible"
        >
          {navItems.map((item, index) => (
            <motion.li key={index} variants={itemVariants} style={{ marginRight: index < navItems.length - 1 ? '40px' : '0' }}>
              {item.page ? (
                <button 
                  className={`nav-link nav-btn ${currentPage === item.page ? 'active' : ''}`}
                  onClick={() => handleNavClick(item)}
                >
                  {item.name}
                </button>
              ) : (
                <button 
                  className="nav-link nav-btn"
                  onClick={() => {
                    closeMobileMenu();
                    const element = document.getElementById(item.section);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {item.name}
                </button>
              )}
            </motion.li>
          ))}
        </motion.ul>

        {/* CTA Buttons */}
        <div className="nav-buttons">
          <motion.button 
            className="btn-signin"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            SIGN IN
          </motion.button>
          <motion.button 
            className="btn-cta"
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(196, 30, 58, 0.8)' }}
            whileTap={{ scale: 0.95 }}
          >
            START HUNTING
          </motion.button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
